import {
	type AgentAssignedListItemResponseDTO,
	UserTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const canSetMainAdvisor = (advisor?: AgentAssignedListItemResponseDTO) =>
	advisor?.type === UserTypeEnum.Agent && !advisor.isMain;
